import { useEffect, useState } from "react";
import { downloadOrgBlob, uploadOrgBlob } from "../panels/common/UploadBlob";
import { Button, IconButton } from "@mui/material";
import { Upload } from "@mui/icons-material";
import { OrgBlobType } from "../models/OrgBlob";
import { showSnackbar } from "./UniversalDialog";

export interface BlobOrgImageProps {
  blobId: string;
  assigner?: (blobId: string) => void;
  style?: React.CSSProperties;
}
export function BlobOrgImage({ blobId, assigner, style }: BlobOrgImageProps) {
  const [imageDataUrl, setImageDataUrl] = useState<string | null>(null);
  useEffect(() => {
    console.log("Loading Org Blob Image for blobId:", blobId);
    if (!blobId) {
      setImageDataUrl(null);
      return;
    }
    const loader = async () => {
      const arrayBuffer = await downloadOrgBlob(blobId);
      const blob = new Blob([arrayBuffer]);
      const url = URL.createObjectURL(blob);
      setImageDataUrl(url);
      if (assigner) {
        assigner(blobId);
      }
    };
    loader();
    // loadImage();
  }, [blobId]);
  return (
    <div style={{ ...style, position: 'relative' }}>
      {imageDataUrl && <img width={'100%'} src={imageDataUrl} alt="Organization Blob" />}
      {(!imageDataUrl && assigner) && <div>No image uploaded</div>}
      {assigner &&
        <IconButton onClick={() => {
          document.getElementById('org-image-upload')?.click();
        }} style={{ position: 'absolute', right: 5, top: 5, width: 40, height: 40, zIndex: 990 }} component="span">
          <Upload />
        </IconButton>
      }

      {assigner &&
        <input
          type="file"
          id="org-image-upload"
          style={{ display: 'none' }}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              // get array buffer
              const reader = new FileReader();
              reader.onload = async () => {
                const arrayBuffer = reader.result as ArrayBuffer;
                showSnackbar("Uploading image...", "info");
                const orgBlob = await uploadOrgBlob(OrgBlobType.Image, arrayBuffer);
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                setImageDataUrl(url);
                assigner(orgBlob._id);
              };
              reader.readAsArrayBuffer(file);
            }
          }}
        />
      }
    </div>
  );
}